<template>
  <div>
    <v-dialog
      v-model="dialog"
      width="500"
    >
      <template v-slot:activator="{ on, attrs }">
        <a
          v-on="on"
          class="text-truncate d-inline-block"
          v-bind:style="{ maxWidth: maxWidth }"
        >
          {{ text }}
        </a>
      </template>

      <v-card>
        <v-card-title class="headline grey lighten-2">
          {{ title }}
        </v-card-title>

        <v-card-text>
          {{ text }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'truncatedTextDialog',
  props: {
    title: {
      required: false,
      default: null,
    },
    text: {
      required: true,
      type: String,
    },
    maxWidth: {
      required: false,
      default: '256px',
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
};
</script>

<style scoped>

</style>
